import { inject, Inject, Injectable } from '@angular/core';
import { PermissionService } from 'src/app/core/services/permission.service';

@Injectable()
export abstract class DefaultComponent {
    permissionMainKey: string;
    permissionSubKey: string;
    readonly permissionService = inject(PermissionService);

    constructor(@Inject('permissionMainKey') permissionMainKey: string, @Inject('subKey') permissionSubKey: string) {
        this.permissionMainKey = permissionMainKey;
        this.permissionSubKey = permissionSubKey;
    }

    public canRead(): boolean {
        return this.permissionService.canRead(this.permissionMainKey, this.permissionSubKey);
    }

    public canCreate(): boolean {
        return this.permissionService.canCreate(this.permissionMainKey, this.permissionSubKey);
    }

    public canEdit(): boolean {
        return this.permissionService.canEdit(this.permissionMainKey, this.permissionSubKey);
    }

    public canDelete(): boolean {
        return this.permissionService.canDelete(this.permissionMainKey, this.permissionSubKey);
    }
}
